import { useRef } from "react";
import ReactDOM from "react-dom";
import { searchDateSingleFormString, searchFormString } from "src/components/common/common";
import { formatDateYear4 } from "src/utils/string/stringUtil";
import YearPicker from "../../calendar/YearPicker";
import { searchLabelStyle } from "src/components/common/common";
import { searchDateRangeFormString } from "src/components/common/common";

interface Props {
	label: string;
	visible: boolean;
	setVisible: (visible: boolean) => void;
	value?: Date;
	editable?: boolean;
	onChange: (date: Date | undefined) => void;
	pickerPosition: { top: number; left: number };
	setPickerPosition: (pickerPosition: { top: number; left: number }) => void;
	wrapperOption?: {
		wrapperStyle?: string;
		titleStyle?: string;
		dateRangeStyle?: string;
	};
	onEnterKeyDown?: () => void;
}

export const SearchYearSingleForm = (props: Props) => {
	const {
		label,
		visible, setVisible,
		value,
		editable = true,
		onChange,
		pickerPosition, setPickerPosition,
		wrapperOption={
			wrapperStyle: "w-[160px] min-w-[160px] mr-[10px]",
			titleStyle: searchLabelStyle,
			dateRangeStyle: searchDateRangeFormString,
		},
		onEnterKeyDown,
	} = props;

	const inputRef = useRef<HTMLDivElement>(null);

	const handleInputClick = () => {
		if (inputRef.current) {
			const rect = inputRef.current.getBoundingClientRect();
			setPickerPosition({ top: rect.bottom + 4, left: rect.left });
		}
		if (editable) {
			setVisible(true);
		}
	};

	return (
		<div className={`${searchFormString} cursor-pointer ${wrapperOption?.wrapperStyle || "w-[300px]"}`}
				tabIndex={onEnterKeyDown ? 0 : undefined}
				onClick={handleInputClick}
				onKeyDown={(e) => {
					if (e.key !== "Enter" || visible || !onEnterKeyDown) return;
					e.preventDefault();
					onEnterKeyDown();
				}}
			>
			<p className={`h-[24px] flex items-center truncate flex-shrink-0 ${wrapperOption?.titleStyle || ""}`}>
				{label}
			</p>
			<p	ref={inputRef}
				className={`
					${ searchDateSingleFormString }
					cursor-pointer
					${editable ? 'bg-white' : 'bg-gray-100'}
					${wrapperOption?.dateRangeStyle || ""}
					`}
				onClick={(e) =>{ e.stopPropagation(); handleInputClick() }}
				>
				{value ? formatDateYear4(value) : ""}
			</p>
			{visible && editable &&
				ReactDOM.createPortal(
				<>
				<div
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100vw',
						height: '100vh',
						zIndex: 9998,
					}}
					onClick={(e) => {
						e.stopPropagation();
						setVisible(false);
					}}
					/>
					<div style={{
								position: 'absolute',
								top: `${pickerPosition.top}px`,
								left: `${pickerPosition.left}px`,
								zIndex: 9999,
							}}
							onClick={(e) => e.stopPropagation()}
						>
						<YearPicker
							value={value}
							onChange={(date) => {
								onChange(date);
							}}
							onReset={() => {
								const today = new Date();
								onChange(new Date(today.getFullYear(), 0, 1));
								setVisible(false);
							}}
							onConfirm={(date) => {
								onChange(date);
								setVisible(false);
							}}
						/>
					</div>
				</>
				, document.body)
			}
		</div>
	)
}
